export default __webpack_public_path__ + "static/media/d-wall-power.f69d8676.svg";